<template lang="html">

  <section class="configuration_paramters">   
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="configuration_paramters_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Code:</div><input type="text" class="col-lg-3" v-model="codeFilter" placeholder="Code"/>
                <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" v-model="labelFilter" placeholder="Label"/>
              </div>
              <b-button variant="primary" v-b-toggle.configuration_paramters_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Configuration Parameters</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">      
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="4"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.configuration_paramters_filters v-if="false"><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new-int-lab @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
                <!--<b-button variant="primary mr-1"><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary"><i class="mdi mdi-file-import"></i>Import</b-button>-->
              </span>
            </div>
            <b-table ref="configuration_paramters_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->
              <template v-slot:cell(accordionButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">
                  <a role="button" data-toggle="collapse" href="javascript:void(0);" v-b-modal.opt-color-details  @click="curItem=data.item.optItem" aria-expanded="true" aria-controls="collapseOne">
                    <i class="mdi mdi-arrow-right-drop-circle-outline"></i>
                  </a>
                </h4>
                </b-row>
              </template>
              <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </b-row>
              </template>
            </b-table>
            <b-modal id="opt-color-details" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <b-table ref="configuration_paramters_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->
              <template v-slot:cell(accordionButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">
                  <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="expandItem(data.item)" aria-expanded="true" aria-controls="collapseOne">
                    <i class="mdi mdi-arrow-right-drop-circle-outline"></i>
                  </a>
                </h4>
                </b-row>
              </template>
              <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </b-row>
              </template>
              </b-table>
                </b-row>
             </b-container>
            </b-modal>
            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.code" disabled/>
                  <div class="col-lg-3">Description*:</div><input type="text" class="col-lg-3" placeholder="Description" v-model="curItem.description"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Value*:</div><input type="text" class="col-lg-3" placeholder="Value" v-model="curItem.value"/>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-new-int-lab" title="New Configuration Parameters"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.code" />
                  <div class="col-lg-3">Description*:</div><input type="text" class="col-lg-3" placeholder="Description" v-model="newItem.description"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Value*:</div><input type="text" class="col-lg-3" placeholder="Value" v-model="newItem.value"/>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style>
.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}
.table td,
.table th {
  max-width: 25vw;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
export default {
  name: 'configuration_paramters',
  methods: {
    expandItem(element){
      console.log(element)
      this.accordionManager()
    },
    accordionManager () {
      document.querySelectorAll('tr[role=row][data-pk]').forEach(el=>{     
        var tr = document.createElement('tr')
            tr.className = 'expandableContent closed';
        var td = document.createElement('td')
            td.setAttribute('colspan',6);
            td.style.backgroundColor = 'yellow';  

            tr.appendChild(td);
            el.parentNode.appendChild(tr);
            el.parentNode.insertBefore(el,tr)
      })
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.code+'?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value){

          this.setSpinnerStatus(true);
          this.axios
          .delete('/ccb/auth/fe/consoleConfig/' + item.id ,this.authHeader)
          .then(response => {
            this.setSpinnerStatus(false);
            this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
              this.refreshTable();
              this.curItem=null;
            })
          })   
          .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          }).finally(e=>{
            this.setSpinnerStatus(false);
          })
      }
        
      })
     
    },
    saveCurItem(curItem) {
    window.curr = curItem
    this.setSpinnerStatus(true);
    var intLabObj = curItem
    this.axios
    .put('/ccb/auth/fe/consoleConfig/' + curItem.id, intLabObj ,this.authHeader)
    .then(response => { 
      if(response.status == 200) {            
        this.$bvModal.msgBoxOk(response.data.message, {
          okVariant: 'success',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.refreshTable();
        })
     }
    })
    .catch(error => {
      this.$bvModal.msgBoxOk(error.message, {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
    }).finally(e=>{
      this.setSpinnerStatus(false);
      this.$bvModal.hide('modal-edit');
    })
     
    },
    createItem() {
    this.setSpinnerStatus(true);
     var intLabObj = this.newItem     
      intLabObj.language = {id: this.getCurLanguageObj.id}
      this.axios
      .post('/ccb/auth/fe/consoleConfig', intLabObj, this.authHeader)
        .then(response => {
          if(response.status == 200) {
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            this.refreshTable();
          })
        }  
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-new-int-lab');
      })
    },
    search() {
     this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
            optGroup: this.getCurLabelGroup, modelName: this.getCurModel, language: this.getCurLanguage, 
            page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter }
      
      this.axios
      .get('/ccb/auth/fe/consoleConfig/allPaged' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
            console.log(response.data)
            window.datas = response.data;
            this.setSpinnerStatus(false);
            this.setConfigurationParameters(response.data.content)  
            this.totalRowsResult=response.data.totalElements;                   
          });
    },
    btnNew() {
      setTimeout(() => {
        var atG = this.getCurLabelGroup
        
      }, 500);
      
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',
      'setInterfaceLabels',
      'setCurLabelGroup',
      'setConfigurationParameters'
      
    ])
  },
  props: ['action','activeGroup'],
  data () {
    return {
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      curItem: null,
      sortBy:'code',
      sortDesc: false,
      curItem:null,
      newItem : {id:null, language: null,  labelGroup: null, code : null ,label: null ,modelEnableRegexp: 'DEFAULT' , modelDisableRegexp: null},
      fields: [
        {
          key: 'code',
          label: 'code',
          sortable: false
        },
        {
          key: 'description',
          label: 'description',
          sortable: false
        },
        {
          key: 'value',
          label: 'value',
          sortable: false
        },        
        {
          key: 'buttons',
          label: '',
          sortable: false
        }
      ],
      labelFilter: '',
      codeFilter: ''
    }
  },
  computed: {
    items () {
      return (this.getConfigurationParameters && this.getConfigurationParameters.length) ? this.getConfigurationParameters : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',      
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'getInterfaceLabels',
      'getLabelGroupList',
      'getConfigurationParameters',
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        // alert('search')
        this.search();        
       }
     },
    items (oldValue, newValue) {
      console.log(this.$refs)
      this.$refs.configuration_paramters_tab.refresh();
    },
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    window.scoper = this     
        this.search();         
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
